import * as React from 'react';
import { IStateApp } from '../Reducers';
import { connect } from 'react-redux';
import { createActionFetchFaenas } from '../Actions/Session/Actions';
import FilterReport from '../Components/FilterReport';
import Wait from '../Assets/images/wait.svg';
import './ReportSummary.scss';
import { Producer, Branch, Summary } from '../Models/Report';
import { createActionSetProducer, EReport, createActionClearData, createActionSetBranch } from '../Actions/Report/Actions';
import { IReportState } from '../Reducers/Report';
import CardSummary from '../Components/CardSummary';
import { getColorQuality } from '../Models/Colors';
import { IAccount } from '../Models/Account';
import Loading from './Loading';
import SummaryBranch from './SummaryBranch';
import { capitalize } from '../Utils/StrUtil';
import Box from '../Components/Box';
import Emply from 'antd/lib/empty';

export interface IHeaderSummaryProps {
	name: string;
	message: string;
}

const HeaderSummary =(props: IHeaderSummaryProps) => (<div>
	<h1>{props.message} {capitalize(props.name)}</h1>
	<p>Estatus del cobre en Puerto Angamos</p>
</div>)

export interface IReportSummaryProps extends IReportState {
	onFaenas: (id: number) => void;
	onClear: () => void;
	producers: Producer[];
	account: IAccount;
	setProducer: (id: number, idProducer: string, report: EReport) => void;
	setBranch: (id: number, idProducer: string, idBranch: number) => void;
	report: EReport;
	section: string;
}

class ReportSummary extends React.Component<IReportSummaryProps> {
	state = {
		branch: undefined,
		producer: ''
	}
	componentWillMount() {
		this.props.onClear();
		if (this.props.account) {
			this.props.onFaenas(this.props.account.id);
		}
	}

	onChangeProducer(value: string | number) {
		this.setState({...this.state, producer: value });
		this.props.setProducer(this.props.account.id, value as string, this.props.report);
	}

	onChangeBranch(value: string | number) {
		const producer: string  = this.state.producer ? this.state.producer as string : '';
		this.props.setBranch(this.props.account.id, producer , value as number);
		this.setState({...this.state, branch: value });
	}

	render() {
		if (this.props.producers.length === 1 && !this.props.announced && !this.props.isRequestAnnounced) {
			this.props.setProducer(this.props.account.id, this.props.producers[0].id, this.props.report);
		}
		const showBox = this.props.announced !== undefined && !this.props.isRequestAnnounced;
		return (
			<div className='ReportSummary'>
				<h1>Detalle del cobre en estado de {this.props.section}</h1>
				<FilterReport
					selected={this.props.announced}
					onChangeBranch={this.onChangeBranch.bind(this)}
					onChangeProducer={this.onChangeProducer.bind(this)}
					producers={this.props.producers}
				/>
				{!showBox && (
					<div className='ReportSummary-Content'>
						{this.props.isRequestAnnounced ? <Loading  /> :
						<div className='ReportSummary-Content-Skeleton'>
							<div className='ReportSummary-Content-Image'>
								<img alt='presentation-wait' src={Wait} />
							</div>
							<div className='ReportSummary-Content-Message'>
								<div>
									<h2>
										Para una mejor búsqueda te invitamos a seleccionar una{' '}
										<span> minera y faena</span>
									</h2>
								</div>
							</div>
						</div>}
					</div>
				)}
				{showBox && !this.state.branch && this.renderSummary()}
				{showBox && this.state.branch && this.renderBranch()}
			</div>
		);
	}

	private renderSummary() {
		const producer = this.props.producers.find(p => p.id === this.state.producer);

		if (!this.props.announced || this.props.announced.total <= 0) {
			return <Box loading={false}>
				<div className="CardSummary">
					<Emply description="No tenemos datos para mostrar" />
				</div>
			</Box>
		}
		if (this.props.announced) {
			return (<div className="ReportSummary-Chart">
						<CardSummary header={<HeaderSummary message="Totalidad de cobre en empresa " name={producer ? producer!.name : '' } />} loading={this.props.isRequestAnnounced} titleItem="Kton de cobre según faena" titleGraph="Visualización faenas asignadas en Kton" data={this.props.announced!.branchs.map(
							(b: Branch, index: number) => ({
								name: b.name,
								total: b.total,
								color: getColorQuality(index)
							})
						)} />
						<CardSummary header={<HeaderSummary message="Calidad de cobre en empresa "  name={producer ? producer!.name : '' } />}  loading={this.props.isRequestShipment} titleItem="Calidad de cobre según faena" titleGraph="Visualización calidad del cobre total" data={this.props.announced!.quality.map(
							(s: Summary, index: number) => ({
								...s,
								color: getColorQuality(index)
							})
						)} />
				</div>)
		}
	}

	private renderBranch() {
		return <SummaryBranch report={this.props.section} reportType={this.props.report} loading={this.props.isRequestShipment} selected={this.props.announced!} shipmentData={this.props.shipmentSummary!} selectedBranch={this.state.branch!} />;
	}
}

const mapProps = (state: IStateApp) => ({
	...state.report,
	account: state.session.account
});

const mapAction = (dispatch: any) => ({
	onFaenas: (id: number) => dispatch(createActionFetchFaenas(id, false)),
	onClear: () => dispatch(createActionClearData(EReport.Announced)),
	setProducer: (id: number, idProducer: string, report: EReport) => dispatch(createActionSetProducer(id, idProducer, report)),
	setBranch: (id: number, idProducer: string, idBranch: number) => dispatch(createActionSetBranch(id, idProducer, idBranch))
});

export default connect<IReportSummaryProps>(
	mapProps as any,
	mapAction
)(ReportSummary) as any;
